















import { Component, Vue } from "vue-property-decorator"
import SecurityModule from "@/store/modules/SecurityModule"

@Component
export default class Navigation extends Vue {
  get isFocalPoint(): boolean {
    return SecurityModule.isFocalPoint
  }
}
